/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */

import { DATE_TIME_FORMAT } from "@lhd/constants";
import moment from "moment";
import { Parser } from "expr-eval";

const IF = (cond: any, trueVal: any, falseVal: any) => {
  return cond ? trueVal : falseVal;
};

const AND = (...args: any[]) => {
  return args.every(Boolean);
};

const OR = (...args: any[]) => {
  return args.some(Boolean);
};

const NOT = (arg: any) => {
  return !arg;
};

const ROUND = (number: number, places = 0) => {
  if (number === null || number === undefined || isNaN(number)) return 0;
  const multiplier = Math.pow(10, places);
  return Math.round(number * multiplier) / multiplier;
};

const ROUNDUP = (number: number, places = 0) => {
  if (number === null || number === undefined || isNaN(number)) return 0;
  const multiplier = Math.pow(10, places);
  return Math.ceil(number * multiplier) / multiplier;
};

const ROUNDDOWN = (number: number, places = 0) => {
  if (number === null || number === undefined || isNaN(number)) return 0;
  const multiplier = Math.pow(10, places);
  return Math.floor(number * multiplier) / multiplier;
};

const CONTAINS = (value: string, searchString: any) => {
  if (typeof value !== "string") {
    return false;
  }
  return value?.includes(searchString);
};

const SUM = (...args: number[]) => {
  return args.reduce(
    (acc, current) =>
      Number(acc) + Number(isNaN(current) || current === null ? 0 : current),
    0,
  );
};

const DATE_FORMAT = (
  value: string | number,
  datetimeFormat = DATE_TIME_FORMAT.DATE_JP,
  timezone: any,
) => {
  if (!value) {
    return "";
  }
  if (timezone) {
    return moment(value)?.zone(timezone)?.format(datetimeFormat);
  } else {
    return moment(value)?.format(datetimeFormat);
  }
};

const YEN = (number: any, places = 0) => {
  const formattedNumber = ROUND(number, places).toLocaleString("ja-JP", {
    style: "currency",
    currency: "JPY",
    maximumFractionDigits: places,
  });
  return formattedNumber;
};

const parser = new Parser();
parser.functions.IF = IF;
parser.functions.AND = AND;
parser.functions.OR = OR;
parser.functions.NOT = NOT;
parser.functions.ROUND = ROUND;
parser.functions.ROUNDUP = ROUNDUP;
parser.functions.ROUNDDOWN = ROUNDDOWN;
parser.functions.CONTAINS = CONTAINS;
parser.functions.SUM = SUM;
parser.functions.DATE_FORMAT = DATE_FORMAT;
parser.functions.YEN = YEN;

export const calculatedValue = ({ fieldValues }: { fieldValues: any }) => {
  const evaluateFormula = (formula: any) => {
    if (typeof formula !== "string" || !formula.trim()) {
      return;
    }

    try {
      const expr = parser.parse(formula);
      const variables = expr.variables();
      const evalValues: Record<string, any> = {};
      variables.forEach((variable) => {
        const val = fieldValues?.[variable];
        evalValues[variable] = val !== undefined ? val : null;
      });
      return expr.evaluate(evalValues);
    } catch (error) {
      return;
    }
  };

  return {
    evaluateFormula,
  };

  // // Example usage:
  // const fieldValues = {
  //   Total_score: 90,
  //   Written: 60,
  //   Practical_Skill: 100,
  //   Date_and_time: "2020-04-01",
  // };

  // const inputFormula = 'IF(AND(Written>=80,Practical_Skill>=80),"Pass","Retest")';
  // const inputFormula =
  //   'DATE_FORMAT(Date_and_time, "MM-dd-YYYY HH:mm", "America/Los_Angeles")';

  // const result = evaluateFormula(formula, fieldValues);
};
